module.exports = __webpack_public_path__ + "static/media/threat-forecast.154c535b.svg";